import { HiArrowSmLeft, HiArrowSmRight } from "react-icons/hi";

export default function NavArrows({ stage, activeQuestion, questionCount, handlePrevQuestion, handleNextQuestion }) {
    return (
        <div className="navigationArrows" style={{ position: "fixed", bottom: "150px", right: "100px" }}>
            <button disabled={stage === 1 && activeQuestion === 1} onClick={handlePrevQuestion}>
                <HiArrowSmLeft />
            </button>
            <button disabled={activeQuestion == questionCount} onClick={handleNextQuestion}>
                <HiArrowSmRight />
            </button>
        </div>
    );
}
